import type { SlaTrackingData, SlaTrackingStatus } from "shared";

const STATUS_PRIORITY: Record<string, number> = {
  breached: 5,
  at_risk: 4,
  paused: 3,
  on_track: 2,
  met: 1,
  pending: 0,
};

export const getWorstStatus = (
  a: SlaTrackingStatus,
  b: SlaTrackingStatus,
): SlaTrackingStatus =>
  (STATUS_PRIORITY[a] ?? 0) >= (STATUS_PRIORITY[b] ?? 0) ? a : b;

/**
 * Converts an MQTT SLA message payload into a Partial<SlaTrackingData>
 * for merging into the ticket list cache.
 */
export const mapMqttToSlaFields = (data: {
  timerType?: string;
  newStatus?: SlaTrackingStatus;
  elapsedMinutes?: number;
  targetMinutes?: number;
  completedAt?: string | null;
  type?: string;
  firstResponseTargetMinutes?: number;
  resolutionTargetMinutes?: number;
}): Partial<SlaTrackingData> => {
  // Handle targets_updated messages (from policy changes)
  if (data.type === "targets_updated") {
    return {
      ...(data.firstResponseTargetMinutes !== undefined && {
        firstResponseTargetMinutes: data.firstResponseTargetMinutes,
      }),
      ...(data.resolutionTargetMinutes !== undefined && {
        resolutionTargetMinutes: data.resolutionTargetMinutes,
      }),
    };
  }

  // Handle status change messages
  if (data.timerType === "first_response") {
    return {
      firstResponseStatus: data.newStatus,
      firstResponseElapsedMinutes: data.elapsedMinutes ?? null,
      ...(data.targetMinutes !== undefined && {
        firstResponseTargetMinutes: data.targetMinutes,
      }),
      ...(data.completedAt !== undefined && {
        firstResponseCompletedAt: data.completedAt,
      }),
    };
  }
  return {
    resolutionStatus: data.newStatus,
    resolutionElapsedMinutes: data.elapsedMinutes ?? null,
    ...(data.targetMinutes !== undefined && {
      resolutionTargetMinutes: data.targetMinutes,
    }),
    ...(data.completedAt !== undefined && {
      resolutionCompletedAt: data.completedAt,
    }),
  };
};
